const cities = [
  { name: "Rivera", x: 222, y: 34, label: true },
  { name: "Salto", x: 64, y: 102, label: true },
  { name: "Paysandú", x: 94, y: 160, label: false },
  { name: "Tacuarembó", x: 172, y: 110, label: false },
  { name: "Melo", x: 282, y: 96, label: false },
  { name: "Rocha", x: 322, y: 190, label: false },
  { name: "Punta del Este", x: 298, y: 252, label: true },
  { name: "Montevideo", x: 232, y: 292, label: true },
  { name: "Colonia", x: 145, y: 268, label: true },
];

export default function Uruguay() {
  return (
    <section className="section" id="uruguay" data-testid="uruguay-section">
      <div className="container uruguay-inner">
        <div className="uruguay-copy reveal">
          <h2>Pensada para Uruguay</h2>
          <p className="uruguay-lead">
            Datos oficiales de UTE Mueve, precios en pesos uruguayos, rutas nacionales.
          </p>
          <ul className="uruguay-chips" data-testid="uruguay-chips">
            <li>Red UTE Mueve · Mové · eOne</li>
            <li>Precios en $U</li>
            <li>Rutas nacionales</li>
            <li>208 cargadores mapeados</li>
          </ul>
        </div>
        <div className="map-card reveal" data-testid="uruguay-map">
          <svg viewBox="0 0 360 380" role="img" aria-label="Mapa de Uruguay con cargadores en las ciudades principales">
            <path
              className="uy-shape"
              d="M85,25 C120,14 160,12 192,20 C232,28 266,46 300,74 C324,94 342,106 340,126 C337,160 332,176 328,196 C322,226 312,244 300,254 C290,266 278,271 262,281 C248,291 241,299 230,301 C205,307 176,295 156,285 C139,277 129,270 121,255 C109,232 105,220 101,205 C95,185 93,175 91,160 C87,140 73,125 63,105 C55,84 60,54 85,25 Z"
            />
            {cities.map((c) => (
              <g key={c.name} className="city">
                <circle className="city-halo" cx={c.x} cy={c.y} r="4" />
                <circle className="city-dot" cx={c.x} cy={c.y} r="3.4" />
                {c.label && (
                  <text x={c.x} y={c.y - 9} textAnchor="middle" className="city-label">
                    {c.name}
                  </text>
                )}
              </g>
            ))}
          </svg>
        </div>
      </div>
    </section>
  );
}
